var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('MajorScheme'),_c('MoreScheme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }